import { TransportLoad } from '@services/requests/orderService/types';

export const getGroupedTransportLoad = (transportLoads: TransportLoad[]) => {
  return Object.values(
    transportLoads.reduce((prev, item) => {
      const hashKey = `${item.transportTypeId}-${item.usedWeight}`;
      if (!(hashKey in prev)) {
        prev[hashKey] = [];
      }
      prev[hashKey].push(item);

      return prev;
    }, {} as Record<string, TransportLoad[]>)
  );
};
